"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Button = _interopRequireDefault(require("../Button"));

var _Trigger = _interopRequireDefault(require("../Trigger"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _style = _interopRequireDefault(require("./style"));

var _FaceWrapper = _interopRequireDefault(require("./components/FaceWrapper"));

var _Item = _interopRequireDefault(require("./components/Item"));

var _utils = require("./utils");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
/**
 * Dropdown component to select value from options.
 */

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Choose...' : _ref$placeholder,
      value = _ref.value,
      plainTitle = _ref.plainTitle,
      onSelect = _ref.onSelect,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$closeOnSelection = _ref.closeOnSelection,
      closeOnSelection = _ref$closeOnSelection === void 0 ? true : _ref$closeOnSelection,
      _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
      closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? true : _ref$closeOnOutsideCl,
      menuClassName = _ref.menuClassName,
      menuStyle = _ref.menuStyle,
      _ref$positionVertical = _ref.positionVertical,
      positionVertical = _ref$positionVertical === void 0 ? 'left' : _ref$positionVertical,
      _ref$positionHorizont = _ref.positionHorizontal,
      positionHorizontal = _ref$positionHorizont === void 0 ? 'bottom' : _ref$positionHorizont,
      titleClassName = _ref.titleClassName,
      maxHeight = _ref.maxHeight,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      _ref$menuTestId = _ref.menuTestId,
      menuTestId = _ref$menuTestId === void 0 ? 'dropdown-menu' : _ref$menuTestId,
      menuId = _ref.menuId,
      searchable = _ref.searchable,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'search' : _ref$searchPlaceholde,
      onToggle = _ref.onToggle,
      open = _ref.open,
      customTitle = _ref.customTitle,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "placeholder", "value", "plainTitle", "onSelect", "defaultOpen", "closeOnSelection", "closeOnOutsideClick", "menuClassName", "menuStyle", "positionVertical", "positionHorizontal", "titleClassName", "maxHeight", "kind", "menuTestId", "menuId", "searchable", "searchPlaceholder", "onToggle", "open", "customTitle"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });

  var _React$useState = React.useState(defaultOpen || false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      internalOpen = _React$useState2[0],
      setInternalOpen = _React$useState2[1];

  React.useEffect(function () {
    if (internalOpen && typeof open !== 'undefined') setInternalOpen(open || false);
  }, [open, internalOpen]);

  var _toggle = function _toggle(open) {
    setInternalOpen(open);

    if (onToggle) {
      onToggle(open);
    }
  };

  var _handleFaceClick = function _handleFaceClick() {
    _toggle(!internalOpen);
  };

  var _handleOutsideClick = function _handleOutsideClick() {
    if (closeOnOutsideClick) _toggle(false);
  };

  var _isSelectedElement = function _isSelectedElement(element) {
    return React.isValidElement(element) && (0, _lodash.isEqual)(element.props.value, value);
  };

  var _renderMenuItem = function _renderMenuItem(child) {
    if (child && _isSelectedElement(child) && React.isValidElement(child)) {
      return React.cloneElement(child, {
        selected: true
      });
    }

    return child;
  };

  var _handleItemClick = function _handleItemClick(element) {
    if (onSelect && React.isValidElement(element)) {
      onSelect(element.props.value);
    }

    if (closeOnSelection) {
      _toggle(false);
    }
  };

  var _buildTitle = function _buildTitle() {
    var title = React.Children.toArray(children).find(function (el) {
      if (React.isValidElement(el)) return _isSelectedElement(el);
    });

    if (title) {
      if (plainTitle) {
        return /*#__PURE__*/React.createElement("div", null, (0, _utils.elementToText)(title));
      }

      return title;
    }

    return placeholder ? /*#__PURE__*/React.createElement("div", null, placeholder) : null;
  };

  return /*#__PURE__*/React.createElement(_Trigger["default"], {
    open: internalOpen,
    face: /*#__PURE__*/React.createElement(_Button["default"].Lite, (0, _extends2["default"])({}, rest, {
      className: (0, _classnames["default"])(classes.BaseAlign, (0, _defineProperty2["default"])({}, classes.KindLite, kind === 'lite'), className),
      onClick: _handleFaceClick,
      active: internalOpen
    }), /*#__PURE__*/React.createElement(_FaceWrapper["default"], {
      left: customTitle || typeof customTitle === 'undefined' && _buildTitle(),
      leftClassName: (0, _classnames["default"])(classes.Title, titleClassName),
      right: "\u25BE",
      minSpace: 10
    })),
    positionVertical: positionVertical,
    positionHorizontal: positionHorizontal,
    onOutsideClick: _handleOutsideClick,
    relativeOffset: 2,
    constraints: [{
      to: 'window',
      attachment: 'together'
    }],
    classes: {
      element: classes.tetherElement
    }
  }, /*#__PURE__*/React.createElement(_Menu["default"], {
    id: menuId ? menuId : menuTestId,
    "data-test-id": menuTestId,
    "data-overlay-menu": true,
    "data-overlay-for": rest.id,
    onItemClick: _handleItemClick,
    className: (0, _classnames["default"])(classes.Menu, menuClassName),
    style: _objectSpread(_objectSpread({}, menuStyle), {}, {
      maxHeight: maxHeight
    }),
    searchable: searchable,
    searchPlaceholder: searchPlaceholder
  }, React.Children.map(children, _renderMenuItem)));
};

exports["default"] = Dropdown;
Dropdown.Item = _Item["default"];
//# sourceMappingURL=index.js.map